import React from "react";
import { Moon, Sun, Disc3, RefreshCw } from "lucide-react";

/**
 * Small settings strip: theme toggle (Luna / Royale Noir), "replay boot"
 * toggle, and a "Burn to CD-R" mixtape button. Rendered under Quick Actions
 * in the left sidebar.
 */
export default function ThemeAndExtras({ theme, onThemeChange, onReplayBoot, onOpenMixtape }) {
  return (
    <div data-testid="theme-extras" className="space-y-1.5">
      <div className="text-[11px] text-[#333] font-bold px-0.5">Skin:</div>
      <div className="flex gap-1">
        <button
          data-testid="theme-luna"
          onClick={() => onThemeChange?.("luna")}
          className={`bevel-btn flex-1 px-2 py-1 text-[11px] flex items-center justify-center gap-1 ${theme === "luna" ? "active" : ""}`}
          title="XP Luna (default)"
        >
          <Sun size={11} className="text-[#F9A825]" />
          Luna
        </button>
        <button
          data-testid="theme-royale"
          onClick={() => onThemeChange?.("royale")}
          className={`bevel-btn flex-1 px-2 py-1 text-[11px] flex items-center justify-center gap-1 ${theme === "royale" ? "active" : ""}`}
          title="Royale Noir (dark)"
        >
          <Moon size={11} className="text-[#8B5CF6]" />
          Noir
        </button>
      </div>

      <button
        data-testid="mixtape-open"
        onClick={onOpenMixtape}
        className="bevel-btn-lemon w-full text-left px-2 py-1.5 text-[11.5px] flex items-center gap-1.5 font-bold"
      >
        <Disc3 size={12} />
        Burn Mixtape to CD-R
      </button>

      <button
        data-testid="replay-boot"
        onClick={onReplayBoot}
        className="bevel-btn w-full text-left px-2 py-1.5 text-[11.5px] flex items-center gap-1.5"
      >
        <RefreshCw size={11} />
        Replay boot splash
      </button>
    </div>
  );
}
